import common from './common.json' with { type: 'json' };
import auth from './auth.json' with { type: 'json' };
import nav from './nav.json' with { type: 'json' };
import admin from './admin.json' with { type: 'json' };
import config from './config.json' with { type: 'json' };
import calendar from './calendar.json' with { type: 'json' };
import messaging from './messaging.json' with { type: 'json' };
export default { common, auth, nav, admin, config, calendar, messaging };
//# sourceMappingURL=index.js.map